import React, { useState, useEffect } from "react";
import Select from "react-select";

const SelectSingleItem = (props) => {
  const {
    option,
    label,
    name,
    value,
    onChange,
    list_name,
    ids,
    disabled,view
  } = props;
// console.log(props);
  
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    // Map the options array to match the format expected by react-select
    const formattedOptions = option.map((item) => ({
      label: item[list_name],
      value: item[ids],
    }));
    setOptions(formattedOptions);

    // Update the selected option if there is a value
    // if (value) {
    //   const selected = formattedOptions.find((opt) => opt.value === value);
    //   setSelectedOption(selected);
    // }
   // console.log(props?.[name]? props?.[name].slice(1, -1):"");
   // console.log(option);
     
     
   
   
       if (props?.[name]) {
        const filteredData = option.find(item => item.id == props?.[name].slice(1, -1));
   // console.log(filteredData);
  //  console.log(filteredData?.categoryName);
  //  console.log({label: filteredData?.categoryName, value: props?.[name]});
        setSelectedOption({label: filteredData?.categoryName, value: props?.[name]});
      }
  }, [option, value, list_name, ids]);
  var selectedArray = [];

  const handleChange = (selectedOption) => {
    // console.log(selectedOption);

    setSelectedOption(selectedOption);
    selectedArray.push(selectedOption.value);

    // Call the parent component's onChange function with the selected value
    onChange(selectedOption ? selectedArray : null);
  };

  return (
    <div>
      <label className="label" id={name}>
        {label}
      </label>
      <Select
        options={options}
        value={selectedOption}
        onChange={handleChange}
        isDisabled={disabled||view}
        isClearable
        placeholder={`Select ${label}`}
      />
    </div>
  );
};

export default SelectSingleItem;
